<form [formGroup]='evaluacionRiesgoGroup' autocomplete="off"  style="padding-top: 10px;">

    <div class='row justify-content-center'>
        <div class="col-sm-6">
            <mat-form-field appearance="outline">
                <mat-select formControlName='probabilidadCtrl' selected="selected"
                    placeholder="Probabilidad">
                    <mat-option *ngFor="let item of probabilidad$ | async" [value]="item.id_probabilidad"
                        matTooltip="{{item.descripcion}}">
                        {{item.nombre}}
                    </mat-option>
                </mat-select>
                <mat-label>Probabilidad</mat-label>
            </mat-form-field>
        </div>
        <div class="col-sm-6">
            <mat-form-field appearance="outline">
                <mat-select formControlName='impactoCtrl' selected="selected" (selectionChange)="calcularProbabilidadImpacto()"
                    placeholder="Impacto">
                    <mat-option *ngFor="let item of impacto$ | async" [value]="item.id_impacto"
                        matTooltip="{{item.detalle}}" [disabled]="!riesgo.id_probabilidad">
                        {{item.descripcion}}
                    </mat-option>
                </mat-select>
                <mat-label>Impacto</mat-label>
            </mat-form-field>
        </div>
        <div class="col-sm-6">
            <h3 class="card-title">Severidad Riesgo: 
                <p ><span [style.backgroundColor]="colorSeveridad" style = "display: inline-block; width: 20px; height: 20px;">
                </span>&nbsp;&nbsp;{{nombreSeveridad}}</p></h3>
        </div>
        <div class="col-sm-6">
            <mat-form-field appearance="outline">
                <mat-select formControlName='estrategiaCtrl' selected="selected"
                    placeholder="Estrategia a seguir">
                    <mat-option *ngFor="let item of estrategia$ | async" [value]="item.id_estrategia"  matTooltip="{{item.descripcion}}">
                        {{item.estrategia}}
                    </mat-option>
                </mat-select>
                <mat-label>Estrategia a seguir</mat-label>
            </mat-form-field>
        </div>
    </div>

    <div class='row justify-content-end'>
        <div class='col-auto mr-auto'>
            <button mat-button matStepperPrevious class="btn btn-success">
                <i class='material-icons'> arrow_back_ios </i> Anterior
            </button>
        </div>
        <div class='col-auto'>
            <button mat-button matStepperNext [disabled]="evaluacionRiesgoGroup.invalid" class="btn btn-info">
                Siguiente<i class='material-icons'> arrow_forward_ios </i>
            </button>
        </div>

    </div>

</form>
